var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6575 8.55143C11.1382 7.95183 11.4249 7.19288 11.4249 6.36379C11.4249 4.43019 9.85745 2.8627 7.92385 2.8627C5.99025 2.8627 4.42276 4.43019 4.42276 6.36379C4.42276 7.19281 4.70944 7.95169 5.19003 8.55127L5.19348 8.55558C5.29523 8.68235 5.38943 8.81581 5.4873 8.94556C5.65727 9.17091 5.89697 9.48738 6.17546 9.85135C6.69443 10.5296 7.34272 11.3657 7.92426 12.0835C8.50763 11.3642 9.1574 10.5268 9.6774 9.84763C9.95639 9.48325 10.1965 9.16648 10.3667 8.94092C10.4641 8.8119 10.5565 8.67754 10.6575 8.55143ZM11.5646 9.27852C11.5646 9.27852 11.5636 9.27985 11.5629 9.28078C11.5332 9.32051 11.2603 9.68502 10.865 10.2042C10.2785 10.9744 9.42245 12.0849 8.69051 12.9801C8.29012 13.4699 7.55773 13.4697 7.15757 12.9798C5.90656 11.4481 4.2886 9.28187 4.2886 9.28187L4.28483 9.27717C3.6451 8.47914 3.26245 7.46615 3.26245 6.36379C3.26245 3.78937 5.34943 1.70239 7.92385 1.70239C10.4983 1.70239 12.5853 3.78937 12.5853 6.36379C12.5853 7.04968 12.4371 7.70096 12.1711 8.2874C12.0102 8.64216 11.8061 8.9732 11.5656 9.2738L11.5639 9.27591L11.5629 9.27717H11.5656L11.5646 9.27852Z",
    fill: "#535763"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.92381 6.92364C8.24422 6.92364 8.50396 6.6639 8.50396 6.34349C8.50396 6.02308 8.24422 5.76333 7.92381 5.76333C7.6034 5.76333 7.34365 6.02308 7.34365 6.34349C7.34365 6.6639 7.6034 6.92364 7.92381 6.92364ZM9.66427 6.34349C9.66427 7.30471 8.88504 8.08394 7.92381 8.08394C6.96258 8.08394 6.18335 7.30471 6.18335 6.34349C6.18335 5.38226 6.96258 4.60303 7.92381 4.60303C8.88504 4.60303 9.66427 5.38226 9.66427 6.34349Z",
    fill: "#535763"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.6b3cd5cd3454c3bcbf53be2ee176e7a4.svg";
export { ForwardRef as ReactComponent };